import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    label: 'Item {index}',
    moveDown: 'Move down the item',
    moveUp: 'Move up the item',
  },
  fr: {
    label: 'Article {index}',
    moveDown: 'Descendre l’article',
    moveUp: 'Monter l’article',
  },
} as const);

export default locales;
